const initialState = {
  isLoading: false,
  authenticated: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_AUTHENTICATED":
      return {
        ...state,
        authenticated: true,
      };
    case "SET_UNAUTHENTICATED":
      return {
        ...initialState,
      };
    case "USER_DATA_FETCH_STARTED":
      return {
        ...state,
        isLoading: true,
      };
    case "USER_DATA_FETCH_FAILED":
      return {
        ...state,
        isLoading: false,
      };
    case "USER_DATA_FETCH_SUCCESS":
      return {
        ...state,
        fetchSuccess: true,

      };
    case "SET_USER":
      return {
        ...state,
        authenticated: true,
        isLoading: false,
        ...action.payload,
      };
    case "SIDEBAR_ITEMS":
      return {
        ...state,
        sideBarItems: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
